import React from 'react';
import { Box, Flex, Button, Tooltip } from '@chakra-ui/react';
import { FaPencilAlt, FaFont, FaCheck, FaTimes, FaEraser, FaUndo, FaTrash } from 'react-icons/fa';

const TOOLS = [
  { id: 'pen', label: 'Lápiz', Icon: FaPencilAlt },
  { id: 'text', label: 'Texto', Icon: FaFont },
  { id: 'check', label: 'Marca correcta', Icon: FaCheck, iconColor: '#1d9e75' },
  { id: 'x', label: 'Marca incorrecta', Icon: FaTimes, iconColor: '#e24b4a' },
  { id: 'eraser', label: 'Borrador', Icon: FaEraser },
];

const COLORS = ['#1d9e75', '#185fa5', '#e24b4a'];

export default function Toolbar({
  tool,
  setTool,
  color,
  setColor,
  onUndo,
  onClearAll,
  disabled,
}) {
  return (
    <Flex
      bg="gray.50"
      borderBottom="1px solid"
      borderColor="gray.200"
      px={2}
      py={2}
      gap={2}
      alignItems="center"
      flexWrap="wrap"
      borderTopRadius="md"
    >
      {TOOLS.map(({ id, label, Icon, iconColor }) => {
        const active = tool === id;
        return (
          <Tooltip key={id} label={label} fontSize="xs">
            <Button
              size="sm"
              variant="outline"
              isDisabled={disabled}
              onClick={() => setTool(id)}
              bg={active ? '#eeedfe' : 'white'}
              borderColor={active ? '#574feb' : 'gray.300'}
              color={active ? '#3c3489' : 'gray.700'}
              leftIcon={<Icon color={iconColor || 'currentColor'} size={13} />}
              fontWeight="normal"
              fontSize="13px"
              _hover={{ bg: active ? '#eeedfe' : 'gray.100' }}
            >
              {label}
            </Button>
          </Tooltip>
        );
      })}

      <Box w="1px" h="22px" bg="gray.200" mx={1} />

      {COLORS.map((c) => (
        <Tooltip key={c} label={`Color ${c}`} fontSize="xs">
          <Box
            as="button"
            type="button"
            disabled={disabled}
            onClick={() => setColor(c)}
            w="22px"
            h="22px"
            borderRadius="full"
            bg={c}
            border="2px solid white"
            outline={color === c ? '2px solid #574feb' : '1px solid #d1d5db'}
            outlineOffset={color === c ? '1px' : '0'}
            cursor="pointer"
          />
        </Tooltip>
      ))}

      <Box flex="1" />

      <Tooltip label="Deshacer última anotación" fontSize="xs">
        <Button
          size="sm"
          variant="outline"
          isDisabled={disabled}
          onClick={onUndo}
          color="gray.600"
          leftIcon={<FaUndo size={12} />}
          fontWeight="normal"
          fontSize="12px"
        >
          Deshacer
        </Button>
      </Tooltip>
      <Tooltip label="Eliminar todas las anotaciones de esta página" fontSize="xs">
        <Button
          size="sm"
          variant="outline"
          isDisabled={disabled}
          onClick={onClearAll}
          color="#791f1f"
          borderColor="#f7c1c1"
          leftIcon={<FaTrash size={12} />}
          fontWeight="normal"
          fontSize="12px"
        >
          Limpiar
        </Button>
      </Tooltip>
    </Flex>
  );
}
